import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { LockIcon, DownloadIcon } from 'lucide-react';
export function FinalOffer() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const handleBuyClick = () => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'The Biological Auto-Scan',
        content_type: 'product',
        value: 27,
        currency: 'USD'
      });
    }
  };
  return <section id="pricing" ref={ref} className="w-full bg-dark-navy py-24 px-6 md:px-12" data-id="element-13">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto text-center space-y-12" data-id="element-14">
        <div className="space-y-6" data-id="element-15">
          <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-16">
            Get the Full Biological Auto-Scan Encyclopedia Today
          </h2>
          <p className="text-xl text-stone-300" data-id="element-17">
            Start listening to what your body has been trying to tell you for
            years.
          </p>
        </div>

        <div className="bg-dark-navy-light border-2 border-teal-accent/50 rounded-2xl p-8 md:p-12 space-y-8 cyan-glow-strong relative overflow-hidden" data-id="element-18">
          <div className="absolute inset-0 bg-cyan-bloom opacity-20 pointer-events-none" data-id="element-19"></div>
          <div className="space-y-4 relative z-10" data-id="element-20">
            <p className="text-stone-400 text-lg line-through" data-id="element-21">
              Regular Price: $47
            </p>
            <div className="space-y-2" data-id="element-22">
              <p className="text-teal-accent text-xl font-semibold" data-id="element-23">
                Today's Digital Price:
              </p>
              <p className="text-6xl md:text-7xl font-bold text-white" data-id="element-24">$27</p>
            </div>
          </div>

          <motion.a href="https://thedailyedit.it.com/products/the-biological-auto-scan" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-amber-cta hover:bg-amber-cta/90 text-white font-bold text-xl px-12 py-6 rounded-lg shadow-[0_0_20px_rgba(255,77,0,0.3)] hover:shadow-[0_0_30px_rgba(255,77,0,0.5)] inline-flex items-center gap-4 transition-all w-full md:w-auto justify-center relative z-10 no-underline" data-id="element-25">
            <DownloadIcon className="w-6 h-6" data-id="element-26" />
            DOWNLOAD MY BIOLOGICAL MAP NOW
          </motion.a>

          <div className="flex items-center justify-center gap-2 text-stone-400 text-sm relative z-10" data-id="element-27">
            <LockIcon className="w-4 h-4" data-id="element-28" />
            <p data-id="element-29">
              Instant PDF access after purchase. Secure 256-bit encrypted
              checkout.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}